import { path } from 'ramda';

import { FEATURE_NAME as $, CURRENT, MEDICATIONS } from './consts';

export const getMedicalHistory = path([$, CURRENT]);
export const getMedicalHistoryProp = (name) => path([$, CURRENT, name]);

export const getMedications = path([$, MEDICATIONS]);
export const getMedicationsProp = (id) => path([$, MEDICATIONS, id]);
